<!-- Header Structure -->
<template>
  <v-toolbar
    class="Vuely-toolbar Header"
    height="55"
    fixed>
    <v-btn @click="triggerDrawerHandler" :class="!showDrawer ? '' : 'ml-1'" fab medium flat v-if="showDrawer">
      <v-icon>menu</v-icon>
    </v-btn>
    <app-logo></app-logo>
<!--    <<brand-select></brand-select>-->
    <user-block class="mr-3"></user-block>
  </v-toolbar>
</template>

<script>
import UserBlock from './fragments/user_block'
import AppLogo from './fragments/app_logo'
import BrandSelect from './fragments/BrandSelect'
import helper from 'util/helpers'
import {mapGetters, mapMutations} from 'vuex'
import eventBus from '@/event_bus'

export default {
  data () {
    return {
      enableDefaultSidebar: false,
      windowWidth: 0,
      showDrawer: false
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    if (window.innerWidth < 1264) {
      this.isMobileHandler(true)
    }
  },
  computed: {
    ...mapGetters([
      'darkMode',
      'drawer'
    ])
  },
  watch: {
    windowWidth (newVal, oldVal) {
      this.showDrawer = newVal < 1264
      this.isMobileHandler(newVal < 1264)
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapMutations([
      'isMobileHandler'
    ]),
    getMenuLink (link) {
      return '/' + helper.getCurrentAppLayout(this.$router) + link
    },
    handleResize () {
      this.windowWidth = window.innerWidth
    },
    triggerDrawerHandler () {
      eventBus.$emit('TRIGGER_DRAWER_HANDLER')
    }
  },
  components: {
    UserBlock,
    AppLogo,
    BrandSelect
  }
}
</script>
<style>
  .Header {
    z-index: 10;
  }

  .light-success{
    background: linear-gradient(180deg, #00D0BD 0%, #007ADF 100%);
  }
</style>



// WEBPACK FOOTER //
// src/components/templates/header/header.vue